// extracted by mini-css-extract-plugin
export var heading = "tableOfContents-module--heading--76f3c";
export var linkListItem = "tableOfContents-module--linkListItem--d2a9e";
export var sectionLink = "tableOfContents-module--sectionLink--6afd2";
export var sectionLinkList = "tableOfContents-module--sectionLinkList--10e38";
export var sectionName = "tableOfContents-module--sectionName--509fc";
export var tableOfContents = "tableOfContents-module--tableOfContents--8cbb7";